import { useEffect } from 'react';

export default function useFavicon(href: string) {
    useEffect(() => {
        const link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
        if (!link) return;

        const previousHref = link.href;
        link.href = href;

        return () => {
            link.href = previousHref;
        };
    }, [href]);
}
